<template>
    <v-card rounded class="wrapper">
        <div class="outline-text px-2" style="font-size: 2em">
            <v-row no-gutters>
                <v-col>
                    <span
                        v-if="this.info.PartNum"
                        v-html="addSpace(info.PartNum, 5)"
                    ></span>
                    <span v-else>
                        <v-progress-circular
                            color="blue-lighten-3"
                            indeterminate
                        />
                    </span>
                    <span>{{ info.AsmblDesc }}</span>
                </v-col>
            </v-row>
            <v-divider
                :thickness="2"
                class="border-opacity-50"
                color="white"
            ></v-divider>
            <v-row no-gutters>
                <v-col>
                    <span
                        v-if="this.info.ProjectID"
                        v-html="addSpace(info.ProjectID, 5)"
                    ></span>
                    <span v-else>
                        <v-progress-circular
                            color="blue-lighten-3"
                            indeterminate
                        />
                    </span>
                    <span>{{ info.Description }}</span>
                    <v-btn
                        v-if="manager"
                        @click="deleteFromTablet"
                        style="margin-left: 10px"
                        variant="elevated"
                        color="danger">
                        (X) Remove From Tablet
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <v-row no-gutters>
            <v-col cols="8">
                <!--ACTIVE USER BAR-->
                <v-card>
                    <v-row
                        v-if="this.activeUser.length === 0"
                        class="noActiveEmployee px-2"
                        no-gutters
                    >
                        <v-col> 0 Active Employee</v-col>
                    </v-row>
                    <v-row
                        v-else-if="this.activeUser.length === 1"
                        class="activeEmployee px-2"
                        no-gutters
                    >
                        <v-col>{{ this.activeUser[0].Name }} Active</v-col>
                    </v-row>
                    <v-row v-else class="activeEmployee px-2" no-gutters>
                        <v-col>
                            {{ this.activeUser.length }} Active Employees
                        </v-col>
                    </v-row>

                </v-card>

                <!--JOB INFO CARD-->
                <JobInfo
                    :rowID="rowID"
                    :job_object="job_object"
                    v-if="this.cardView === 'info'"
                ></JobInfo>
                <!--REQUEST CARD-->
                <RequestMaterial
                    :material="info"
                    :partNumber="info.PartNum"
                    :comingFromLabor="true"
                    v-else-if="this.cardView === 'request'"
                    style="flex-direction: column"
                ></RequestMaterial>
                <!--LABOR HISTORY CARD-->
                <LaborHistory
                    :jobInfo="info"
                    :machine_id="mainMachineProps"
                    v-else-if="this.cardView === 'history'"
                ></LaborHistory>
                <v-card
                    v-else
                    class="text-center py-10"
                    style="
                        min-height: 50vh;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    "
                >
                    <v-progress-circular
                        color="blue-lighten-3"
                        indeterminate
                        :size="120"
                    >
                        <v-img
                            src="/images/d3_connect.png"
                            :size="10"
                            class="loading-spinner"
                            :style="{
                                marginLeft: '9px',
                            }"
                            indeterminate
                        ></v-img>
                    </v-progress-circular>
                </v-card>
            </v-col>

            <!----------------------------MENU BUTTONS---------------------------->
            <v-col cols="4" class="text-center px-1">
                <v-row no-gutters>
                    <v-col
                        v-for="(button, index) in buttons"
                        :key="index"
                        :cols="buttonCols(index)"
                        class="pa-1"
                    >
                        <v-btn
                            v-if="showButton(index)"
                            :color="button.color"
                            class="custom-button"
                            variant="elevated"
                            @click="button.action"
                        >
                            <div class="button-content">
                                <v-icon style="font-size: 5em"
                                    >{{ button.icon }}
                                </v-icon>
                                <div class="button-text">
                                    {{ button.label }}
                                </div>
                            </div>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>

    <!------------------------------DIALOGS------------------------------>

    <!--EMPLOYEE PUNCH SCREEN-->
    <v-dialog
        v-model="employeePunchScreen"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
        persistent
    >
        <EmployeePunch
            :jobInfo="info"
            :punchInOut="punchInOut"
            @closeEmployeePunchScreen="closeEmployeePunchScreen"
            @clockInJob="clockInJob"
            @clockInDetails="getClockInDetails"
            @clockOutJob="clockOutJob"
            @clockOutDetails="getClockOutDetails"
        ></EmployeePunch>
    </v-dialog>

    <!--MANAGER PUNCH SCREEN-->
    <v-dialog
        v-model="employeePunchScreen"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
        persistent
    >
        <!-- <ManagerPunch
                :jobInfo="info"
                :rowID="rowID"
                @closeManagerPunchScreen="closeManagerPunchScreen"
                @clockOutJob="clockOutJob"
                @clockOutDetails="getClockOutDetails"
            ></ManagerPunch> -->
        <EmployeePunch
            :jobInfo="info"
            :punchInOut="punchInOut"
            @closeEmployeePunchScreen="closeEmployeePunchScreen"
            @clockInJob="clockInJob"
            @clockInDetails="getClockInDetails"
            @clockOutJob="clockOutJob"
            @clockOutDetails="getClockOutDetails"
        ></EmployeePunch>
    </v-dialog>

    <!--PART PHOTO SCREEN-->
    <v-dialog
        v-model="partPhoto"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
    >
        <PartPhoto
            :part="info.PartNum"
            @closePartPhotoScreen="closePartPhotoScreen"
        ></PartPhoto>
    </v-dialog>

    <!--PRINT LABEL SCREEN-->
    <v-dialog
        v-model="printLabel"
        transition="dialog-bottom-transition"
        persistent
    >
        <PrintLabelUA
            :multiLabel="labelContent"
            @closePrintLabel="closePrintLabelScreen"
        ></PrintLabelUA>
    </v-dialog>

    <!--CLOCK IN/OUT LOADING SPINNER-->
    <v-dialog
        v-model="clockingIn"
        max-width="40vw"
        transition="dialog-bottom-transition"
        persistent
    >
        <ClockingLoader title="Clocking In" :name="clockInDetails.Name" />
    </v-dialog>
    <v-dialog
        v-model="clockingOut"
        max-width="40vw"
        transition="dialog-bottom-transition"
        persistent
    >
        <ClockingLoader title="Clocking Out" :name="clockOutDetails.name" />
    </v-dialog>

    <!--RETURN PART TO INVENTORY (IF OP IS COMPLETE) -->
    <v-dialog v-model="returnToInventoryDialog" persistent>
            <v-card>
                <v-card-title>Return Part to Inventory</v-card-title>
                <v-card-subtitle>
                    This operation has been completed. Please enter the quantity and bin number to return the part to inventory.
                </v-card-subtitle>
                <v-card-text>
                    <ReturnsToInventory
                        :prefillData="completedOperationData"
                        @partsReturnedToInventory="handlePartsReturnedToInventory"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
</template>
<script>
import axios from "axios";
import JobInfo from "./JobInfo.vue";
import LaborHistory from "./LaborHistory.vue";
import PrintLabelUA from "./PrintLabelUA.vue";
import EmployeePunch from "./EmployeePunch.vue";
import ManagerPunch from "./ManagerPunch.vue";
import PartPhoto from "./PartPhoto.vue";
import ClockingLoader from "./ClockingLoader.vue";
import RequestMaterial from "../../../components/CNC/CNCOperationDash/RequestMaterial.vue";
import ReturnsToInventory from "../../../components/Logistics/ReturnsToInventory/ReturnsToInventory.vue";

export default {
    name: "Tablet",
    components: {
        JobInfo,
        LaborHistory,
        PrintLabelUA,
        EmployeePunch,
        ManagerPunch,
        PartPhoto,
        ClockingLoader,
        RequestMaterial,
        ReturnsToInventory,
    },
    emits: ["closeTabletView"],
    props: {
        rowID: {
            type: [String, Number],
            default: null,
        },
        mainMachineProps: {
            type: String,
            default: null,
        },
        job_object:{
            type: Object,
            default:{}
        },
        manager:{
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            employeePunchScreen: false,
            managerPunchScreen: false,
            clockingIn: false,
            clockingOut: false,
            printLabel: false,
            partPhoto: false,
            cardView: "info",
            punchInOut: "",
            clockInDetails: null,
            clockOutDetails: null,
            activeUser: [],
            info: [],
            labelContent: [],
            buttons: [
                {
                    label: "Job Info",
                    icon: "mdi mdi-information",
                    color: "primary",
                    action: this.refreshJobInfo,
                },
                {
                    label: "Request",
                    icon: "mdi mdi-download",
                    color: "primary",
                    action: this.getRequest,
                },
                {
                    label: "Labor History",
                    icon: "mdi mdi-history",
                    color: "primary",
                    action: this.getHistory,
                },
                {
                    label: "Back",
                    icon: "mdi mdi-arrow-left-bold",
                    color: "primary",
                    action: this.closeTabletView,
                },
                {
                    label: "Part Photo",
                    icon: "mdi mdi-camera",
                    color: "primary",
                    action: this.openPartPhotoScreen,
                },
                {
                    label: "Print Label",
                    icon: "mdi mdi-printer",
                    color: "primary",
                    action: this.openPrintLabelScreen,
                },
                {
                    label: "Clock In",
                    icon: "mdi mdi-login",
                    color: "success",
                    action: this.openClockInScreen,
                },
                {
                    label: "Clock Out",
                    icon: "mdi mdi-logout",
                    color: "error",
                    action: this.openClockOutScreen,
                },
            ],
            machine_id: null,
            returnToInventoryDialog: false,
            completedOperationData: null,
        };
    },
    mounted() {
        this.initializeData();
        // this.interval = setInterval(this.refreshData, 120000);
    },
    beforeDestroy() {
        // clearInterval(this.interval);
    },
    computed: {
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
    },
    watch: {
        mainMachineProps: {
            handler(val) {

            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        async initializeData() {
            await this.getUser();
            await this.getJobInfo();
        },
        async refreshData() {
            await this.getUser();
            await this.refreshJobInfo();
        },
        async getJobInfo() {
            if (this.rowID !== null) {
                try {
                    await axios
                        .get(
                            route("legacy-api.getAllJobInfo", {
                                JobOperId: this.rowID,
                                Department: this.deptTitle,
                            })
                        )
                        .then((response) => {
                            this.info = response.data[0];
                        });
                } catch (err) {
                    console.log(err);
                }
                this.cardView = "info";
            }
        },
        async getUser() {
            if (this.rowID !== null) {
                try {
                    await axios
                        .get(
                            route("legacy-api.getActiveUser", {
                                SysRowID: this.rowID, // "BE7DAF30-8A8C-46A2-AA75-43B9D0B0670B"
                                ResourceGrp: this.deptTitle,
                            })
                        )
                        .then((response) => {
                            this.activeUser = response.data;
                        });
                } catch (err) {
                    console.log(err);
                }
            }
        },
        async clockInJob() {
            this.clockingIn = true;
            try {
                await axios
                    .get(
                        route("legacy-api.getSpecificTablet", {
                            tabletId: this.resourceId,
                        })
                    )
                    .then((response) => {
                        this.machine_id = response.data.data;
                    });
            } catch (err) {
                console.log(err);
            }
            try {
                let resourceId = this.machine_id;
                if (this.deptTitle === "ASM") {
                    resourceId = "ASM20";
                }

                await axios
                    .post(route("legacy-api.clockInJob"), {
                        AssemblyId: this.job_object.AssemblyId,
                        JobId: this.job_object.JobId,
                        JobOperId: this.rowID,
                        EmpID: this.clockInDetails.EmployeeNum,

                        JobNum: this.info.JobNum,
                        AsmSeq: this.info.AsmSeq,
                        OprSeq: this.info.OprSeq,
                        ResourceID: resourceId,
                    })
                    .then((response) => {

                        if (
                            response.data.Complete == 1
                        ) {
                            this.getUser();
                        } else {

                            alert('error');
                        }
                    })
                    .finally(() => {
                        this.clockingIn = false;
                    });
            } catch (err) {
                console.log(err);
                alert(err.response.data.errors)
            }
        },
        async clockOutJob() {
            this.clockingOut = true;
            try {
                await axios
                    .post(
                        route("legacy-api.clockOutJob", {
                            JobNum: this.info.JobNum,
                            AsmSeq: this.info.AsmSeq,
                            OprSeq: this.info.OprSeq,
                            EmpID: this.clockOutDetails.empID,
                            LaborQty: this.clockOutDetails.laborQty,
                            ScrapQty: this.clockOutDetails.scrapQty,
                            ScrapReason: this.clockOutDetails.scrapReason,
                            Complete: 0,
                            OpCode: this.deptTitle,

                        })
                    )
                    .then((response) => {
                        if (response.data?.OpComplete == 1 && this.deptTitle === "CNC") {
                            this.completedOperationData = {
                                JobNum: this.info.JobNum,
                                AssemblySeq: this.info.AsmSeq,
                                PartNum: this.info.PartNum,
                                OprSeq: this.info.OprSeq,
                                remaining_qty: this.clockOutDetails.laborQty,
                                returned_by: response.data?.CompletedBy,
                            };
                            // this.returnToInventoryDialog = true;
                        }
                        this.getUser();
                        this.refreshJobInfo();
                    })
                    .finally(() => {
                        this.clockingOut = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },

        async deleteFromTablet(){
            this.clockingOut = true;
            try {
                await axios
                    .post(
                        route("legacy-api.completeOpr", {
                            JobNum: this.info.JobNum,
                            AsmSeq: this.info.AsmSeq,
                            OprSeq: this.info.OprSeq,
                            OpCode: this.deptTitle,
                            RemoveFromTablet: 1,
                        })
                    )
                    .then((response) => {
                        if(response.data == 1){
                            location.reload();
                        }

                    })
                    .finally(() => {
                        this.clockingOut = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        showButton(index) {
            if (
                this.activeUser.length === 0 &&
                index === this.buttons.length - 1
            ) {
                return false;
            }
            return true;
        },
        buttonCols(index) {
            if (
                this.activeUser.length === 0 &&
                index === this.buttons.length - 2
            ) {
                return 12;
            }
            return 6;
        },
        createLabel() {
            let obj = {
                JobNum: this.info.JobNum,
                AsmSeq: this.info.AsmSeq,
                OprSeq: this.info.OprSeq,
                AssemblyPart: this.info.PartNum,
                AssemblyDescription: this.info.Description,
                MtlPart: this.info.MtlNum,
                MtlDescription: this.info.MtlDesc,
            };
            this.labelContent.push(obj);
        },
        getHistory() {
            this.cardView = "history";
        },
        getRequest() {
            this.cardView = "request";
        },
        closeTabletView() {
            this.$emit("closeTabletView");
        },
        openPartPhotoScreen() {
            this.partPhoto = true;
        },
        closePartPhotoScreen() {
            this.partPhoto = false;
        },
        openPrintLabelScreen() {
            this.createLabel();
            this.printLabel = true;
        },
        closePrintLabelScreen() {
            this.printLabel = false;
            this.labelContent = [];
        },
        openClockInScreen() {
            this.punchInOut = "in";
            this.employeePunchScreen = true;
        },
        openClockOutScreen() {
            this.punchInOut = "out";
            this.employeePunchScreen = true;
        },
        closeEmployeePunchScreen() {
            this.employeePunchScreen = false;
        },
        openManagerPunchScreen() {
            this.managerPunchScreen = true;
        },
        closeManagerPunchScreen() {
            this.managerPunchScreen = false;
        },
        getClockInDetails(dtl) {
            this.clockInDetails = dtl;
        },
        getClockOutDetails(dtl) {
            this.clockOutDetails = dtl;
        },
        addSpace(text, count) {
            return text + "&nbsp;".repeat(count);
        },
        refreshJobInfo() {
            this.cardView = "";
            this.getJobInfo();
        },
        handlePartsReturnedToInventory() {
            this.returnToInventoryDialog = false;
        },
    },
};
</script>
<style lang="css" scoped>
.wrapper {
    background-color: #facd90;
    width: 100%;
    overflow-y: auto;
}

.wrapper::-webkit-scrollbar {
    display: none;
}

.noActiveEmployee {
    background-color: #9e9e9e;
    font-size: 1.5em;
}

.activeEmployee {
    background-color: #008e00;
    font-size: 1.5em;
}

.outline-text {
    color: white;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
        1px 1px 0 #000;
}

.dialog-toolbar {
    font-size: 2em;
    line-height: 1.2;
}

.custom-button {
    width: 100%;
    padding: 8px;
    height: 100%;
    width: 100%;
}

.button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.button-text {
    margin-top: 6px;
    font-size: 1vw;
}
</style>
